/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SetupParameterTemplateListViewModel } from '../../models/setup-parameter-template-list-view-model';

export interface GetSetupParameterTemplateById$Params {
  setupParameterTemplateId: number;
}

export function getSetupParameterTemplateById(http: HttpClient, rootUrl: string, params: GetSetupParameterTemplateById$Params, context?: HttpContext): Observable<StrictHttpResponse<SetupParameterTemplateListViewModel>> {
  const rb = new RequestBuilder(rootUrl, getSetupParameterTemplateById.PATH, 'get');
  if (params) {
    rb.path('setupParameterTemplateId', params.setupParameterTemplateId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SetupParameterTemplateListViewModel>;
    })
  );
}

getSetupParameterTemplateById.PATH = '/api/v1/SetupParameter/GetSetupParameterTemplateById/{setupParameterTemplateId}';
